import { render, staticRenderFns } from "./MeetingMinute.vue?vue&type=template&id=bc374c2a&scoped=true&"
import script from "./MeetingMinute.vue?vue&type=script&lang=js&"
export * from "./MeetingMinute.vue?vue&type=script&lang=js&"
import style0 from "./MeetingMinute.vue?vue&type=style&index=0&id=bc374c2a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc374c2a",
  null
  
)

export default component.exports